

import emailIcon from './images/icons/email-icon.svg';
import wtspIcon from './images/icons/whatsapp-icon.svg';
import reactIcon from './images/react-icon.svg';

import {Link } from 'react-router-dom';

export default function Footer () {




    return(


        <div class='footer' style={{'z-index': '3'}}>



            <div class='footerContainer'>

                <div class="halfV">

                        <div class="footerSection" style={{  'border-top': '0px'}}>

                            <div style={{"color": "#cdcdcd",  'font-size': '17px', 'font-weight': '600'}}>Want to hire me ? Let's connect</div>
                            <div class='footerItem'>
                                    <div class='footerIcon'>
                                        <a href="tel:+4917659532446"><img src={wtspIcon} width="17px" height="18px" margin-left="1px"></img></a>
                                        </div>

                                    <div class='footerIcon'>
                                        <a href="mailto:benzianeoyacine@gmail.com"><img src={emailIcon} width="20px" height="20px"></img></a>
                                    </div>
                                    </div>  
                        </div>


                        <div class="footerSection"  id= "emptyFooterItem" style={{  'border-top': '0px'}}/>

                        
                        <div class="footerSection" style={{  'border-top': '0px'}}>
                            
                            <div class="footerList" style={{'margin-top': '-7px'}}>
                                        <div style={{'text-transform': 'uppercase', fontWeight: 600 }}>
                                            <a href='#home'>Home</a><br/>
                                            <a href='#projects'>Projects</a><br/>
                                            <Link to="/about" style={{  'text-decoration': 'none'}}>About<br/></Link>
                                            <Link to="/contact" style={{  'text-decoration': 'none'}}>Contact<br/></Link>

                                        </div>
                            </div>


                            <div style={{display: 'flex', border: 'none', justifyContent: 'end', 'margin-top': '-21px', padding: '0 0 7px 5px', 'font-size': '15px'}}>

                                    {/* <div style={{display: 'flex', justifyContent: 'center', 'align-items': 'center', width: '69px', height: '29px', 'background-color': '#343434', 'color': '#bcbcbc', 'border-radius': '9px',}}>
                                        <div> <strong>EN</strong> | FR</div>
                                    </div>     */}
                            </div>

                        </div>
                </div>


                <div class="halfV">

                        <div class="footerSection">

                            <div class="footerList" style={{margin: '3px 0 3px 0', 'text-transform': 'uppercase'}}><strong>Past clients & collaborators</strong></div>
                            
                            <div class="footerList">
                                
                                Valyans<br/>
                                AGI Group<br/>
                                Dishop<br/>
                                Image Factory<br/>
                                Stage Maroc<br/>
                                Sigma Technologies<br/>
                                </div>
                                

                            </div>


                        <div class="footerSection">


                            <div class="footerList" style={{margin: '3px 0 3px 0', 'text-transform': 'uppercase'}}><strong>Skills & Tools</strong></div>
                            
                            <div class="footerList">
                                
                                UX UI Design<br/>
                                CSS, JS, React, Next.js<br/>
                                Node.js, Python<br/>
                                SQL, Supabase<br/>
                                Motion Design<br/>
                                </div>
                                
                        </div>
                        <div class="footerSection"  id= "emptyFooterItem" >

                        <div class='footerList'style={{margin: '3px 0 3px 0'}}>Created by Yacine Benziane w/<img src={reactIcon} style = {{height: '21px', 'transform': 'translate(3px,5px)'}}/></div>

                        </div>
                </div>


            </div>

        </div>
    )
}